const runtimeConfig =
  typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ || {} : {};

const getConfigValue = (key, fallback = "") => {
  const value = runtimeConfig[key];
  if (typeof value === "string" && value.trim() !== "") {
    return value;
  }
  return fallback;
};

export const CURRENT_URL = getConfigValue(
  "REACT_APP_CURRENT_URL",
  process.env.REACT_APP_CURRENT_URL || "",
);

export const CLIENT_URL = getConfigValue(
  "REACT_APP_CLIENT_URL",
  process.env.REACT_APP_CLIENT_URL || "",
);

if (!CURRENT_URL || !CLIENT_URL) {
  console.error(
    "Missing runtime config values. Check /env.js generation and environment injection.",
  );
}